import { WorkingHours } from '../../model/v2/workinghours';

export class PharmacyDetails {
  id: number;
  name: string;
  address: string;
  npi: string;
  primaryPhoneNumber: string;
  workingHours: WorkingHours[];
  checked?: boolean;
  location:location[];
}

export class location{
  zipcode:string;
}
